import { COMPONENT_TYPES } from '../../constants';
import { getComponent, getEditorComponent } from './registry';
// import { LoginComponent } from './Login';
// import LoginEditor from './Login/Login.editor';
// import { SignupComponent } from './Signup';
import SignupEditor from './Signup/Signup.editor';
import { BinaryLegsComponent } from './BinaryLegs';
import BinaryLegsEditor from './BinaryLegs/BinaryLegs.editor';
import { UnilevelLegsComponent } from './UnilevelLegs';
import UnilevelLegsEditor from './UnilevelLegs/UnilevelLegs.editor';
import { MembershipSignupComponent } from './MembershipSignup';
import MembershipSignupEditor from './MembershipSignup/MembershipSignup.editor';
import { CustomMembershipSignupComponent } from './CustomMembershipSignup';
import CustomMembershipSignupEditor from './CustomMembershipSignup/CustomMembershipSignup.editor';
// import { UserProfileComponent } from './UserProfile'; // 스킨 시스템 사용
import UserProfileEditor from './UserProfile/UserProfile.editor';
import MainBannerComponent from './MainBanner';
import MainBannerEditor from './MainBanner/MainBanner.editor';
import { FAQComponent } from './FAQ';
import FAQEditor from './FAQ/FAQ.editor';
import { CompanyHistoryComponent } from './CompanyHistory';
import CompanyHistoryEditor from './CompanyHistory/CompanyHistory.editor';
import { RichEditorComponent } from './RichEditor';
import RichEditorEditor from './RichEditor/RichEditor.editor';
import { ImageTextComponent } from './ImageText';
import ImageTextEditor from './ImageText/ImageText.editor';
import { TrendingItemsComponent } from './TrendingItems';
import TrendingItemsEditor from './TrendingItems/TrendingItems.editor';
import { FixedBgTextComponent } from './FixedBgText';
import FixedBgTextEditor from './FixedBgText/FixedBgText.editor';
// ProductList는 스킨 시스템을 사용하므로 직접 import하지 않음
// import { ProductListComponent } from './ProductList';
// import ProductListEditor from './ProductList/ProductList.editor';
// import { ProductSliderComponent } from './ProductSlider'; // 스킨 시스템 사용
import ProductSliderEditor from './ProductSlider/ProductSlider.editor';
import { ImageSliderComponent } from './ImageSlider';
// import { ProductDetailComponent } from './ProductDetail'; // 스킨 시스템 사용
import ProductDetailEditor from './ProductDetail/ProductDetail.editor';
// import { CartComponent } from './Cart'; // 스킨 시스템 사용
import CartEditor from './Cart/Cart.editor';
// import { PaymentComponent } from './Payment'; // 스킨 시스템 사용
import PaymentEditor from './Payment/Payment.editor';
import { PaymentSuccessComponent } from './PaymentSuccess';
import PaymentSuccessEditor from './PaymentSuccess/PaymentSuccess.editor';
import { PaymentFailComponent } from './PaymentFail';
import PaymentFailEditor from './PaymentFail/PaymentFail.editor';
// import { OrderHistoryComponent } from './OrderHistory'; // 스킨 시스템 사용
import OrderHistoryEditor from './OrderHistory/OrderHistory.editor';
import { AssetHistoryComponent } from './AssetHistory';
import AssetHistoryEditor from './AssetHistory/AssetHistory.editor';
import { BenefitSummaryComponent } from './BenefitSummary';
import BenefitSummaryEditor from './BenefitSummary/BenefitSummary.editor';
import { RecommendedUsersComponent } from './RecommendedUsers';
import RecommendedUsersEditor from './RecommendedUsers/RecommendedUsers.editor';
import { MobileLayoutComponent } from './MobileLayout';
import MobileLayoutEditor from './MobileLayout/MobileLayout.editor';
// import { BoardComponent } from './Board'; // 스킨 시스템 사용
import BoardEditor from './Board/Board.editor';
import { PayLetterPaymentComponent } from './PayLetterPayment';
import PayLetterPaymentEditor from './PayLetterPayment/PayLetterPayment.editor';
import { PaymentWerouteComponent } from './PaymentWeroute';
import PaymentWerouteEditor from './PaymentWeroute/PaymentWeroute.editor';
import { PaymentWerouteSuccessComponent } from './PaymentWerouteSuccess';
import PaymentWerouteSuccessEditor from './PaymentWerouteSuccess/PaymentWerouteSuccess.editor';
import { PaymentWerouteFailComponent } from './PaymentWerouteFail';
import PaymentWerouteFailEditor from './PaymentWerouteFail/PaymentWerouteFail.editor';
import { QuickMenuComponent } from './QuickMenu';
import QuickMenuEditor from './QuickMenu/QuickMenu.editor';
import { DualBannerComponent } from '../DualBanner';
import DualBannerEditor from '../DualBanner/DualBanner.editor';
// import { SearchBarComponent } from './SearchBar'; // 스킨 시스템 사용
import SearchBarEditor from './SearchBar/SearchBar.editor';

/**
 * 컴포넌트 타입 매핑 테이블
 * 모듈화된 컴포넌트와 해당 타입을 매핑
 */
const componentMappings: Record<string, React.ComponentType<any>> = {
  // 기본 컴포넌트
  // LOGIN은 스킨 시스템을 사용하므로 레지스트리에서 가져오도록 제거
  // SIGNUP도 스킨 시스템을 사용하므로 레지스트리에서 가져오도록 제거
  // [COMPONENT_TYPES.SIGNUP]: SignupComponent,
  [COMPONENT_TYPES.BINARY_LEGS]: BinaryLegsComponent,
  [COMPONENT_TYPES.UNILEVEL_LEGS]: UnilevelLegsComponent,
  [COMPONENT_TYPES.MEMBERSHIP_SIGNUP]: MembershipSignupComponent,
  [COMPONENT_TYPES.CUSTOM_MEMBERSHIP_SIGNUP]: CustomMembershipSignupComponent,
  // [COMPONENT_TYPES.USER_PROFILE]: UserProfileComponent, // 스킨 시스템 사용
  [COMPONENT_TYPES.MAIN_BANNER]: MainBannerComponent,
  [COMPONENT_TYPES.FAQ]: FAQComponent,
  [COMPONENT_TYPES.COMPANY_HISTORY]: CompanyHistoryComponent,
  [COMPONENT_TYPES.RICH_EDITOR]: RichEditorComponent,
  [COMPONENT_TYPES.IMAGE_TEXT]: ImageTextComponent,
  [COMPONENT_TYPES.TRENDING_ITEMS]: TrendingItemsComponent,
  [COMPONENT_TYPES.FIXED_BG_TEXT]: FixedBgTextComponent,
  // [COMPONENT_TYPES.PRODUCT_LIST]: ProductListComponent, // 스킨 시스템 사용
  // PRODUCT_SLIDER는 레지스트리에서 관리 (외부 스킨 지원)
  [COMPONENT_TYPES.IMAGE_SLIDER]: ImageSliderComponent,
  // [COMPONENT_TYPES.PRODUCT_DETAIL]: ProductDetailComponent, // 스킨 시스템 사용
  // [COMPONENT_TYPES.CART]: CartComponent, // 스킨 시스템 사용
  // [COMPONENT_TYPES.PAYMENT]: PaymentComponent, // 스킨 시스템 사용
  [COMPONENT_TYPES.PAYLETTER_PAYMENT]: PayLetterPaymentComponent,
  [COMPONENT_TYPES.PAYMENT_WEROUTE]: PaymentWerouteComponent,
  [COMPONENT_TYPES.PAYMENT_SUCCESS]: PaymentSuccessComponent,
  [COMPONENT_TYPES.PAYMENT_FAIL]: PaymentFailComponent,
  // [COMPONENT_TYPES.ORDER_HISTORY]: OrderHistoryComponent, // 스킨 시스템 사용
  [COMPONENT_TYPES.PAYMENT_WEROUTE_SUCCESS]: PaymentWerouteSuccessComponent,
  [COMPONENT_TYPES.PAYMENT_WEROUTE_FAIL]: PaymentWerouteFailComponent,
  // [COMPONENT_TYPES.ORDER_HISTORY]: OrderHistoryComponent, // 스킨 시스템 사용
  [COMPONENT_TYPES.ASSET_HISTORY]: AssetHistoryComponent,
  [COMPONENT_TYPES.BENEFIT_SUMMARY]: BenefitSummaryComponent,
  [COMPONENT_TYPES.RECOMMENDED_USERS]: RecommendedUsersComponent,
  [COMPONENT_TYPES.MOBILE_LAYOUT]: MobileLayoutComponent,
  // [COMPONENT_TYPES.BOARD]: BoardComponent, // 스킨 시스템 사용을 위해 주석 처리
  [COMPONENT_TYPES.QUICK_MENU]: QuickMenuComponent,
  [COMPONENT_TYPES.DUAL_BANNER]: DualBannerComponent,

  // 문자열 기반 대체 키 (호환성 유지)
  // 'LOGIN': LoginComponent, // LOGIN은 스킨 시스템을 사용하므로 레지스트리에서 가져오도록 제거
  // 'SIGNUP': SignupComponent, // SIGNUP도 스킨 시스템을 사용하므로 레지스트리에서 가져오도록 제거
  'BINARY_LEGS': BinaryLegsComponent,
  'UNILEVEL_LEGS': UnilevelLegsComponent,
  'MEMBERSHIP_SIGNUP': MembershipSignupComponent,
  'CUSTOM_MEMBERSHIP_SIGNUP': CustomMembershipSignupComponent,
  // 'USER_PROFILE': UserProfileComponent, // 스킨 시스템 사용
  'MAIN_BANNER': MainBannerComponent,
  'FAQ': FAQComponent,
  'COMPANY_HISTORY': CompanyHistoryComponent,
  'RICH_EDITOR': RichEditorComponent,
  'IMAGE_TEXT': ImageTextComponent,
  'TRENDING_ITEMS': TrendingItemsComponent,
  'FIXED_BG_TEXT': FixedBgTextComponent,
  // 'PRODUCT_LIST': ProductListComponent, // 스킨 시스템 사용
  // 'PRODUCT_SLIDER': ProductSliderComponent, // 스킨 시스템 사용
  'IMAGE_SLIDER': ImageSliderComponent,
  // 'PRODUCT_DETAIL': ProductDetailComponent, // 스킨 시스템 사용
  // 'CART': CartComponent, // 스킨 시스템 사용
  // 'PAYMENT': PaymentComponent, // 스킨 시스템 사용
  'PAYLETTER_PAYMENT': PayLetterPaymentComponent,
  'PAYMENT_WEROUTE': PaymentWerouteComponent,
  'PAYMENT_SUCCESS': PaymentSuccessComponent,
  'PAYMENT_FAIL': PaymentFailComponent,
  // 'ORDER_HISTORY': OrderHistoryComponent, // 스킨 시스템 사용
  'PAYMENT_WEROUTE_SUCCESS': PaymentWerouteSuccessComponent,
  'PAYMENT_WEROUTE_FAIL': PaymentWerouteFailComponent,

  // 'ORDER_HISTORY': OrderHistoryComponent, // 스킨 시스템 사용

  'ASSET_HISTORY': AssetHistoryComponent,
  'BENEFIT_SUMMARY': BenefitSummaryComponent,
  'RECOMMENDED_USERS': RecommendedUsersComponent,
  'MOBILE_LAYOUT': MobileLayoutComponent,
  // 'BOARD': BoardComponent, // 스킨 시스템 사용을 위해 주석 처리
  'QUICK_MENU': QuickMenuComponent,
  'DUAL_BANNER': DualBannerComponent,
};

/**
 * 에디터 컴포넌트 타입 매핑 테이블
 * 모듈화된 에디터 컴포넌트와 해당 타입을 매핑
 */
const editorComponentMappings: Record<string, React.ComponentType<any>> = {
  // 기본 컴포넌트
  // LOGIN은 스킨 시스템을 사용하므로 레지스트리에서 가져오도록 제거
  [COMPONENT_TYPES.SIGNUP]: SignupEditor,
  [COMPONENT_TYPES.BINARY_LEGS]: BinaryLegsEditor,
  [COMPONENT_TYPES.UNILEVEL_LEGS]: UnilevelLegsEditor,
  [COMPONENT_TYPES.MEMBERSHIP_SIGNUP]: MembershipSignupEditor,
  [COMPONENT_TYPES.CUSTOM_MEMBERSHIP_SIGNUP]: CustomMembershipSignupEditor,
  [COMPONENT_TYPES.USER_PROFILE]: UserProfileEditor,
  [COMPONENT_TYPES.MAIN_BANNER]: MainBannerEditor,
  [COMPONENT_TYPES.FAQ]: FAQEditor,
  [COMPONENT_TYPES.COMPANY_HISTORY]: CompanyHistoryEditor,
  [COMPONENT_TYPES.RICH_EDITOR]: RichEditorEditor,
  [COMPONENT_TYPES.IMAGE_TEXT]: ImageTextEditor,
  [COMPONENT_TYPES.TRENDING_ITEMS]: TrendingItemsEditor,
  [COMPONENT_TYPES.FIXED_BG_TEXT]: FixedBgTextEditor,
  // [COMPONENT_TYPES.PRODUCT_LIST]: ProductListEditor, // 스킨 시스템 사용
  [COMPONENT_TYPES.PRODUCT_SLIDER]: ProductSliderEditor,
  [COMPONENT_TYPES.IMAGE_SLIDER]: ImageSliderComponent,
  [COMPONENT_TYPES.PRODUCT_DETAIL]: ProductDetailEditor,
  [COMPONENT_TYPES.CART]: CartEditor,
  [COMPONENT_TYPES.PAYMENT]: PaymentEditor,
  [COMPONENT_TYPES.PAYLETTER_PAYMENT]: PayLetterPaymentEditor,
  [COMPONENT_TYPES.PAYMENT_WEROUTE]: PaymentWerouteEditor,
  [COMPONENT_TYPES.PAYMENT_SUCCESS]: PaymentSuccessEditor,
  [COMPONENT_TYPES.PAYMENT_FAIL]: PaymentFailEditor,
  [COMPONENT_TYPES.PAYMENT_WEROUTE_SUCCESS]: PaymentWerouteSuccessEditor,
  [COMPONENT_TYPES.PAYMENT_WEROUTE_FAIL]: PaymentWerouteFailEditor,
  [COMPONENT_TYPES.ORDER_HISTORY]: OrderHistoryEditor,
  [COMPONENT_TYPES.ASSET_HISTORY]: AssetHistoryEditor,
  [COMPONENT_TYPES.BENEFIT_SUMMARY]: BenefitSummaryEditor,
  [COMPONENT_TYPES.RECOMMENDED_USERS]: RecommendedUsersEditor,
  [COMPONENT_TYPES.MOBILE_LAYOUT]: MobileLayoutEditor,
  [COMPONENT_TYPES.BOARD]: BoardEditor,
  [COMPONENT_TYPES.QUICK_MENU]: QuickMenuEditor,
  [COMPONENT_TYPES.DUAL_BANNER]: DualBannerEditor,

  // 문자열 기반 대체 키 (호환성 유지)
  // 'LOGIN': LoginEditor, // 스킨 시스템 사용
  // 'SIGNUP': SignupEditor, // 스킨 시스템 사용
  'BINARY_LEGS': BinaryLegsEditor,
  'UNILEVEL_LEGS': UnilevelLegsEditor,
  'MEMBERSHIP_SIGNUP': MembershipSignupEditor,
  'CUSTOM_MEMBERSHIP_SIGNUP': CustomMembershipSignupEditor,
  'USER_PROFILE': UserProfileEditor,
  'MAIN_BANNER': MainBannerEditor,
  'FAQ': FAQEditor,
  'COMPANY_HISTORY': CompanyHistoryEditor,
  'RICH_EDITOR': RichEditorEditor,
  'IMAGE_TEXT': ImageTextEditor,
  'TRENDING_ITEMS': TrendingItemsEditor,
  'FIXED_BG_TEXT': FixedBgTextEditor,
  // 'PRODUCT_LIST': ProductListEditor, // 스킨 시스템 사용
  'PRODUCT_SLIDER': ProductSliderEditor,
  'IMAGE_SLIDER': ImageSliderComponent,
  'PRODUCT_DETAIL': ProductDetailEditor,
  'CART': CartEditor,
  'PAYMENT': PaymentEditor,
  'PAYLETTER_PAYMENT': PayLetterPaymentEditor,
  'PAYMENT_WEROUTE': PaymentWerouteEditor,
  'PAYMENT_SUCCESS': PaymentSuccessEditor,
  'PAYMENT_FAIL': PaymentFailEditor,
  'PAYMENT_WEROUTE_SUCCESS': PaymentWerouteSuccessEditor,
  'PAYMENT_WEROUTE_FAIL': PaymentWerouteFailEditor,
  'ORDER_HISTORY': OrderHistoryEditor,
  'ASSET_HISTORY': AssetHistoryEditor,
  'BENEFIT_SUMMARY': BenefitSummaryEditor,
  'RECOMMENDED_USERS': RecommendedUsersEditor,
  'MOBILE_LAYOUT': MobileLayoutEditor,
  'BOARD': BoardEditor,
  'QUICK_MENU': QuickMenuEditor,
  'DUAL_BANNER': DualBannerEditor,
  'SEARCH_BAR': SearchBarEditor,
};

/**
 * 타입에 맞는 컴포넌트 반환
 * 모듈화된 컴포넌트가 있으면 그것을 반환하고, 없으면 null 반환
 *
 * @param type 컴포넌트 타입
 * @returns 타입에 맞는 컴포넌트 또는 null
 */
export function getModularizedComponent(type: string): React.ComponentType<any> | null {
  // 타입 정규화
  const normalizedType = String(type).toUpperCase();

  // 🔍 DEBUG: Log component lookup

  // 1. 먼저 직접 매핑 테이블에서 찾기
  if (componentMappings[normalizedType]) {
    return componentMappings[normalizedType];
  }

  // 2. 레지스트리에서 찾기
  const registeredComponent = getComponent(normalizedType);
  if (registeredComponent) {
    return registeredComponent;
  }

  // 없으면 null 반환
  console.warn(`모듈화된 컴포넌트를 찾을 수 없습니다: ${normalizedType}`);
  return null;
}

/**
 * 타입에 맞는 에디터 컴포넌트 반환
 * 모듈화된 에디터 컴포넌트가 있으면 그것을 반환하고, 없으면 null 반환
 *
 * @param type 컴포넌트 타입
 * @returns 타입에 맞는 에디터 컴포넌트 또는 null
 */
export function getModularizedEditorComponent(type: string): React.ComponentType<any> | null {
  // 타입 정규화
  const normalizedType = String(type).toUpperCase();

  // 1. 먼저 직접 매핑 테이블에서 찾기
  if (editorComponentMappings[normalizedType]) {
    return editorComponentMappings[normalizedType];
  }

  // 2. 레지스트리에서 찾기
  const registeredEditorComponent = getEditorComponent(normalizedType);
  if (registeredEditorComponent) {
    return registeredEditorComponent;
  }

  // 없으면 null 반환
  console.warn(`모듈화된 에디터 컴포넌트를 찾을 수 없습니다: ${normalizedType}`);
  return null;
}

/**
 * 컴포넌트가 모듈화되었는지 확인
 *
 * @param type 컴포넌트 타입
 * @returns 모듈화 여부
 */
export function isComponentModularized(type: string): boolean {
  return getModularizedComponent(type) !== null;
}

/**
 * 에디터 컴포넌트가 모듈화되었는지 확인
 *
 * @param type 컴포넌트 타입
 * @returns 모듈화 여부
 */
export function isEditorComponentModularized(type: string): boolean {
  return getModularizedEditorComponent(type) !== null;

} 
